import React, { useContext } from 'react';
import {
  AppBar,
  Avatar,
  Button,
  createMuiTheme,
  Hidden,
  IconButton,
  SwipeableDrawer,
  Toolbar,
  Typography,
} from '@material-ui/core';
import { connect } from 'react-redux';
import { ThemeProvider } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import MenuIcon from '@material-ui/icons/Menu';
import * as authActions from '../../store/auth/authSlice';
import { useHistory } from 'react-router';
import { useTranslation } from 'react-i18next';
import { AuthTokenUtils } from '../../common/authTokenStorage';
import logo from '../../logo126.svg';
import './app-header.scss';
import SideBar from './SideBar';
import * as uiActions from '../../store/uiSlice';
import { completedRoutes } from '../../common/constants';
import PersonIcon from '@material-ui/icons/Person';
import CircularProgress from '@material-ui/core/CircularProgress';
import IsMobileContext from '../../common/IsMobileContext';

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#fff',
    },
  },
  shadows: Array(25).fill('none'),
});

const iOS = process.browser && /iPad|iPhone|iPod/.test(navigator.userAgent);

function AppHeader(props) {
  const { t } = useTranslation();
  const history = useHistory();
  const isMobileDesign = useContext(IsMobileContext);

  const toggleDrawer = (open) => event => {
    if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    props.setSideBarOpenState({ open });
  };

  const handleLogout = () => {
    props.logout();
    history.replace(completedRoutes.userTasks);
  };

  const handleLogin = () => {
    history.replace(completedRoutes.signUpModalItem, { withLogo: true });
  };

  const handleBalanceClick = () => {
    if (history.location.pathname === completedRoutes.userActivity) return;
    history.push(completedRoutes.userActivity);
  };

  const handleGoToTasks = () => {
    history.replace(completedRoutes.userTasks);
  };

  const userName = AuthTokenUtils.getUsername();

  const isBalanceLoading = props.userFetchingState === 'requesting';

  return (
    <ThemeProvider theme={theme}>
      <div className="app-header-root">
        <AppBar position="fixed" style={{ zIndex: props.needFixedPosition ? 1500 : 0 }}>
          <Toolbar classes={{ root: 'toolbar' }}>
            <IconButton edge="start"
                        className="burger-btn"
                        aria-label="menu" onClick={toggleDrawer(!props.isSideBarOpen)}
            >
              <Hidden mdUp>{props.isSideBarOpen ? <CloseIcon /> : <MenuIcon />}</Hidden>
            </IconButton>
            <div className="header-logo" onClick={handleGoToTasks} role="button" tabIndex="0">
              <img src={logo} alt="Like&amp;Go Воронеж" width="41" height="40" />
            </div>
            <Typography variant="h6" className="links-header-cnt">
              {''}
            </Typography>
            <Typography variant="h6">
              <div className="info-cnt">
                {!props.admin && <div className='balance' onClick={handleBalanceClick}>
                  <div className="moderated-balance container">
                    {isBalanceLoading ? <CircularProgress color="inherit" size={24} /> : (
                      <span className="rubble moderated-balance-value">{props.moderatedBalance}</span>
                    )}
                  </div>
                  <div className={`balance container ${isMobileDesign ? '' : 'yellow-bg'}`}>
                    <span className="balance-title">{t('balance.availableBalance')}</span>
                    {isBalanceLoading ? <CircularProgress color="inherit" size={24} /> : (
                      <span className="rubble balance-value">{props.balance}</span>
                    )}
                  </div>
                </div>}
                <Hidden only={['sm', 'xs']}>
                  {props.isLogged ? (
                    <div className="user-info" onClick={handleLogout}>
                      <Avatar className="avatar">
                        <PersonIcon />
                      </Avatar>
                      <div className="log-cnt">
                        <span className="log-info">{userName}</span>
                        {props.admin && <span className="admin-info">{t('common.admin')}</span>}
                      </div>
                    </div>
                  ) : (
                    <Button variant="outlined" className="logout" onClick={handleLogin}>
                      <span className="logout-text">{t('common.login')}</span>
                    </Button>
                  )}
                </Hidden>
              </div>
            </Typography>
          </Toolbar>
        </AppBar>
        <Toolbar />
        <Hidden only={['sm', 'xs']}>
          <Toolbar />
        </Hidden>
        <Hidden mdUp>
          <SwipeableDrawer
            open={props.isSideBarOpen}
            onClose={toggleDrawer(false)}
            onOpen={toggleDrawer(true)}
            disableBackdropTransition={!iOS} disableDiscovery={iOS}
          >
            <SideBar left
                     toggleDrawer={toggleDrawer}
                     userName={userName}
                     handleLogout={handleLogout}
                     handleLogin={handleLogin}
                     admin={props.admin}
                     isLogged={props.isLogged}
            />
          </SwipeableDrawer>
        </Hidden>
      </div>
    </ThemeProvider>
  );
}

const mapStateToProps = (state) => ({
  isSideBarOpen: state.ui.isSideBarOpen,
  needFixedPosition: !state.ui.errorPopupState.isOpen && !state.ui.successPopupState.isOpen,
  balance: state.user.balance,
  moderatedBalance: state.user.moderatedBalance,
  userFetchingState: state.user.fetchingState,
  isLogged: state.auth.isLogged,
});

const actionCreators = {
  logout: authActions.logout,
  setSideBarOpenState: uiActions.setOpenState
};

export default connect(mapStateToProps, actionCreators)(AppHeader);
